var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.737,
    height: 27.903,
    viewBox: "0 0 31.737 27.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_597",
    "data-name": "Rect\\xE1ngulo 597",
    width: 31.737,
    height: 27.903,
    fill: "#ff784e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1205",
    "data-name": "Grupo 1205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1376",
    "data-name": "Trazado 1376",
    d: "M12.4,27.9h-.62c-.069-.019-.135-.043-.206-.055a2.791,2.791,0,0,1-1.961-4,2.888,2.888,0,0,1,2.043-1.508c-.468-.017-.933,0-1.4-.019a2.71,2.71,0,0,1-2.573-1.672,2.61,2.61,0,0,1,.416-2.9,8.108,8.108,0,0,1,1-.858C8,11.918,6.885,6.9,5.765,1.861H5.4c-1.385,0-2.77-.019-4.154.009A1.184,1.184,0,0,1,0,1.179v-.5A1.028,1.028,0,0,1,.909,0c1.86,0,3.72-.008,5.58,0a.923.923,0,0,1,.928.725c.064.217.1.442.151.663.172.771.345,1.543.52,2.326H30.624c.89,0,1.285.521,1.042,1.371q-1.793,6.277-3.587,12.555c-.219.767-.467.954-1.258.954H10.513a3.446,3.446,0,0,0-.372.007.927.927,0,0,0-.771,1.255.983.983,0,0,0,1.05.6H26.977a.936.936,0,1,1,0,1.859c-.434,0-.868,0-1.3,0a.107.107,0,0,0,.077.055,2.784,2.784,0,0,1,1.2,4.923,3.313,3.313,0,0,1-1.4.6h-.62c-.069-.019-.136-.043-.206-.055a2.791,2.791,0,0,1-1.96-4,2.915,2.915,0,0,1,2.039-1.514H12.462c.092.029.118.039.145.045a2.784,2.784,0,0,1,1.2,4.923,3.313,3.313,0,0,1-1.4.6m14-11.17c1.064-3.72,2.121-7.423,3.181-11.131H8.5l2.475,11.131ZM12.085,26.041a.928.928,0,1,0-.919-.937.936.936,0,0,0,.919.937m13.148-1.855a.928.928,0,1,0,.938.918.936.936,0,0,0-.938-.918",
    transform: "translate(0 0)",
    fill: "#ff784e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCar);
export default __webpack_public_path__ + "static/media/shopping-car.24e13c771d623b282210cd4c58d340bd.svg";
export { ForwardRef as ReactComponent };